export const categoriasIniciales = [
  // 🧬 Laboratorio
  { name: "Analizador de Bioquímica", grupo: "Laboratorio" },
  { name: "Analizador de Hematología", grupo: "Laboratorio" },
  { name: "Analizador de Coagulación", grupo: "Laboratorio" },
  { name: "Analizador de Orina", grupo: "Laboratorio" },
  {
    name: "Analizador de Gases Arteriales y Electrolitos",
    grupo: "Laboratorio",
  },
  { name: "Analizador de Inmunoensayo", grupo: "Laboratorio" },
  { name: "Analizador de Biología Molecular PCR", grupo: "Laboratorio" },
  { name: "Analizador de Química", grupo: "Laboratorio" },
  { name: "Analizador de Hemocultivos", grupo: "Laboratorio" },
  { name: "Analizador de Pruebas Especializadas", grupo: "Laboratorio" },
  { name: "Baño Serológico", grupo: "Laboratorio" },
  { name: "Baño de Flotacion", grupo: "Laboratorio" },
  { name: "Baño seco", grupo: "Laboratorio" },
  { name: "Cabina de flujo Laminar", grupo: "Laboratorio" },
  { name: "Centrifuga", grupo: "Laboratorio" },
  { name: "Centrifuga refrigerada", grupo: "Laboratorio" },
  { name: "Microcentrifuga", grupo: "Laboratorio" },
  { name: "Microscopio", grupo: "Laboratorio" },
  { name: "Microscopio Trinocular", grupo: "Laboratorio" },
  { name: "Lector de Microplacas", grupo: "Laboratorio" },
  { name: "Lavador de Microplacas", grupo: "Laboratorio" },
  { name: "Incubadora de Muestras Biológicas", grupo: "Laboratorio" },
  { name: "Horno De Incubación", grupo: "Laboratorio" },
  { name: "Procesador De Tejido", grupo: "Laboratorio" },
  { name: "Termómetro", grupo: "Laboratorio" },
  { name: "Termohigrómetro", grupo: "Laboratorio" },
  { name: "Pipeta", grupo: "Laboratorio" },
  { name: "Probeta", grupo: "Laboratorio" },
  { name: "Fotocolorimetro", grupo: "Laboratorio" },
  { name: "Datalogger", grupo: "Laboratorio" },
  { name: "Nevera", grupo: "Laboratorio" },
  { name: "Congelador", grupo: "Laboratorio" },
  { name: "Horno Secador", grupo: "Laboratorio" },
  { name: "Destilador de Agua", grupo: "Laboratorio" },

  // 🏥 Biomédico
  { name: "Bomba de Infusión", grupo: "Biomédico" },
  { name: "Bomba de Nutrición", grupo: "Biomédico" },
  { name: "Ventilador Mecánico", grupo: "Biomédico" },
  { name: "Desfibrilador", grupo: "Biomédico" },
  { name: "Electrocardiógrafo", grupo: "Biomédico" },
  { name: "Monitor de Signos Vitales", grupo: "Biomédico" },
  { name: "Monitor Fetal", grupo: "Biomédico" },
  { name: "Lámpara Cielítica", grupo: "Biomédico" },
  { name: "Lámpara de Fototerapia", grupo: "Biomédico" },
  { name: "Lampara Calor Radiante", grupo: "Biomédico" },
  { name: "Incubadora Neonatal", grupo: "Biomédico" },
  { name: "Incubadora de Transporte", grupo: "Biomédico" },
  { name: "Cama Hospitalaria", grupo: "Biomédico" },
  { name: "Camilla de transporte", grupo: "Biomédico" },
  { name: "Silla de Ruedas", grupo: "Biomédico" },
  { name: "Cuna Pediátrica", grupo: "Biomédico" },
  { name: "Tensiómetro", grupo: "Biomédico" },
  { name: "Estetoscopio / Fonendoscopio", grupo: "Biomédico" },
  { name: "Otoscopio Digital", grupo: "Biomédico" },
  { name: "Oftalmoscopio Indirecto", grupo: "Biomédico" },
  { name: "Audiómetro", grupo: "Biomédico" },
  { name: "Ecógrafo", grupo: "Biomédico" },
  { name: "Rayos X", grupo: "Biomédico" },
  { name: "Tomógrafo", grupo: "Biomédico" },
  { name: "Laringoscopio", grupo: "Biomédico" },
  { name: "Electrobisturí", grupo: "Biomédico" },
  { name: "Maquina de Anestesia", grupo: "Biomédico" },
  { name: "Perfusor", grupo: "Biomédico" },
  { name: "BPAP", grupo: "Biomédico" },
  { name: "Concentrador De Oxigeno", grupo: "Biomédico" },
  { name: "Nebulizador", grupo: "Biomédico" },
  { name: "Humidificador", grupo: "Biomédico" },
  { name: "Torre de laparoscopia", grupo: "Biomédico" },
  { name: "Videolaringoscopio", grupo: "Biomédico" },
  { name: "Unidad Odontología", grupo: "Biomédico" },
  { name: "Autoclave", grupo: "Biomédico" },
  { name: "Termodesinfectadora", grupo: "Biomédico" },
  { name: "Colposcopio", grupo: "Biomédico" },
  { name: "Simulador Multiparámetro", grupo: "Biomédico" },
  { name: "Simulador Fetal", grupo: "Biomédico" },
  { name: "Ultrasonido", grupo: "Biomédico" },
  { name: "Ventilador Mecánico de Transporte", grupo: "Biomédico" },
  { name: "Sistema Pacs", grupo: "Biomédico" },

  // ⚙️ Industrial / Soporte
  { name: "Planta eléctrica", grupo: "Industrial" },
  { name: "Compresor", grupo: "Industrial" },
  { name: "plc", grupo: "Industrial" },
  { name: "Computador", grupo: "Industrial" },
  { name: "Fuente de Alimentación", grupo: "Industrial" },
  { name: "Osciloscopio", grupo: "Industrial" },
  { name: "Balanzas", grupo: "Industrial" },
  { name: "Balanza de precisión", grupo: "Industrial" },
  { name: "Bascula de piso", grupo: "Industrial" },
  { name: "Manómetro", grupo: "Industrial" },
  { name: "Termómetro Infrarrojo", grupo: "Industrial" },
  { name: "Calentador de Fluido Sanguíneo", grupo: "Industrial" },
  { name: "Cava", grupo: "Industrial" },
  { name: "Flujómetro", grupo: "Industrial" },
  { name: "Extractor manual", grupo: "Industrial" },
  { name: "Agitador Magnético", grupo: "Industrial" },
  { name: "Agitador de plaquetas", grupo: "Industrial" },
  { name: "Cavitron", grupo: "Industrial" },
  { name: "Horno Eléctrico", grupo: "Industrial" },
  { name: "Gramera", grupo: "Industrial" },
];

export default categoriasIniciales;
